import {
    scannerCaseDetailsFragment,
    scannerCaseListItemFragment as scannerCasesItemFragment,
    scannerCasePrintableOrderFormFragment,
} from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const dexisStatusTemplate = gql`
    query dexisStatus {
        dexisStatus {
            authorized
            enabled
            clientId
        }
    }
`;

export const threeShapeStatusTemplate = gql`
    query threeShapeStatus {
        threeShapeStatus {
            authorized
            enabled
            clientId
            codeChallenge
        }
    }
`;

export const meditStatusTemplate = gql`
    query meditStatus {
        meditStatus {
            authorized
            enabled
            clientId
            state
        }
    }
`;

export const pandaStatusTemplate = gql`
    query pandaStatus {
        pandaStatus {
            authorized
            enabled
            clientId
            clientSecret
            codeChallenge
        }
    }
`;

export const pandaEuStatusTemplate = gql`
    query pandaEuStatus {
        pandaEuStatus {
            authorized
            enabled
            clientId
            clientSecret
            codeChallenge
        }
    }
`;

export const dsCoreStatusTemplate = gql`
    query dsCoreStatus {
        dsCoreStatus {
            authorized
            enabled
            clientId
            codeChallenge
        }
    }
`;

export const scannerCasesTemplate = gql`
    query scannerCases($filter: ScannerCaseFilter, $sortOrder: ScannerCaseSortOrder, $limit: Int!, $offset: Int!) {
        scannerCases(filter: $filter, sortOrder: $sortOrder, limit: $limit, offset: $offset) {
            ...scannerCaseListItemFields
            # Selected here rather than in scannerCaseListItemFields: that fragment
            # is also spread into orderDetailsFragment, which already selects this
            # field via scannerCaseDetailsFragment.
            fileProcessingStatus
            # DD-3445: list-only field for the "Construction type" column, kept out
            # of the shared fragment for the same reason.
            constructionTypes {
                restorationType
                label
            }
        }
    }
    ${scannerCasesItemFragment}
`;

export const scannerCaseNotificationCountTemplate = gql`
    query scannerCaseNotificationCount {
        scannerCaseNotificationCount
    }
`;

export const scannerCaseTemplate = gql`
    query scannerCase($caseId: MongoDbObjectId!) {
        scannerCase(caseId: $caseId) {
            ...scannerCaseDetailsFields
            ...scannerCasePrintableOrderFormFields
        }
    }
    ${scannerCaseDetailsFragment}
    ${scannerCasePrintableOrderFormFragment}
`;

export const scannerCaseFileDownloadUrlTemplate = gql`
    query scannerCaseFileDownloadUrl($caseId: MongoDbObjectId!, $sourceFileId: String!) {
        scannerCaseFileDownloadUrl(caseId: $caseId, sourceFileId: $sourceFileId)
    }
`;

export const attachCaseSearchTemplate = gql`
    query attachCaseSearch($orderId: MongoDbObjectId!, $name: String, $pin: String, $limit: Int!, $offset: Int!) {
        attachCaseSearch(orderId: $orderId, name: $name, pin: $pin, limit: $limit, offset: $offset) {
            scannerCases {
                ...scannerCaseDetailsFields
            }
            listType
        }
    }
    ${scannerCaseDetailsFragment}
`;
